import type { HTMLAttributes } from 'react';
import { cn } from '@sib/ui';

export type BadgeLayout = 'vertical' | 'horizontal';

export interface AppStoreBadgesProps extends HTMLAttributes<HTMLDivElement> {
  appStoreAppUrl?: string;
  googlePlayAppUrl?: string;
  onAppStoreClick?: () => void;
  onGooglePlayClick?: () => void;
  layout?: BadgeLayout;
}

export const AppStoreBadges = ({
  appStoreAppUrl,
  googlePlayAppUrl,
  onAppStoreClick,
  onGooglePlayClick,
  layout = 'horizontal',
  className,
  ...props
}: AppStoreBadgesProps) => {
  if (!appStoreAppUrl && !googlePlayAppUrl) return null;

  return (
    <div
      className={cn(
        'flex gap-2',
        layout === 'vertical'
          ? 'w-full flex-col px-4'
          : 'flex-row items-center',
        className
      )}
      {...props}
    >
      {googlePlayAppUrl && (
        <a
          href={googlePlayAppUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onGooglePlayClick}
          className="hover:opacity-80"
        >
          <img
            src="/images/google-play-badge.svg"
            alt="Get it on Google Play"
            className="h-10 w-auto"
          />
        </a>
      )}
      {appStoreAppUrl && (
        <a
          href={appStoreAppUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onAppStoreClick}
          className="hover:opacity-80"
        >
          <img
            src="/images/app-store-badge.svg"
            alt="Download on the App Store"
            className="h-10 w-auto"
          />
        </a>
      )}
    </div>
  );
};
